import { shallowEqual, useSelector } from 'react-redux';
import { getClassicGameData } from '../selectors';

export const useClassicGame = () => ({
  game: useSelector(getClassicGameData, shallowEqual),
});
